import { render, staticRenderFns } from "./BettingTips.vue?vue&type=template&id=81565726&"
import script from "./BettingTips.vue?vue&type=script&lang=js&"
export * from "./BettingTips.vue?vue&type=script&lang=js&"
import style0 from "./BettingTips.vue?vue&type=style&index=0&id=81565726&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports